export const ACTION_TYPES = {
    REQUEST_BUSINESSFIELD: 'REQUEST_BUSINESSFIELD',
    RECEIVE_BUSINESSFIELD: 'RECEIVE_BUSINESSFIELD',
    REQUEST_BO_BUSINESSFIELD: 'REQUEST_BO_BUSINESSFIELD',
    RECEIVE_BO_BUSINESSFIELD: 'RECEIVE_BO_BUSINESSFIELD',
    REQUEST_PARTNER_OR_PARENT_BUSINESSFIELD: 'REQUEST_PARTNER_OR_PARENT_BUSINESSFIELD',
    RECEIVE_PARTNER_OR_PARENT_BUSINESSFIELD: 'RECEIVE_PARTNER_OR_PARENT_BUSINESSFIELD'
};

const initialState = { entities: [], isLoading: false, boBusinessFieldEntities: [], partnerOrParentBusinessFieldEntities: [] };

export const businessFieldActions = {
    requestBusinessFields: (positionId, occupationId) => async (dispatch) => {
        if (occupationId !== undefined) {
            dispatch({ type: ACTION_TYPES.REQUEST_BUSINESSFIELD });
            const url = `api/businessfield?id=${positionId}&occupationId=${occupationId}`;
            const response = await fetch(url);
            const entities = await response.json();

            dispatch({ type: ACTION_TYPES.RECEIVE_BUSINESSFIELD, entities });
        }
    },

    requestBOBusinessFields: (positionId, occupationId) => async (dispatch) => {
        if (occupationId !== undefined) {
            dispatch({ type: ACTION_TYPES.REQUEST_BO_BUSINESSFIELD });
            const url = `api/businessfield?id=${positionId}&occupationId=${occupationId}`;
            const response = await fetch(url);
            const entities = await response.json();

            dispatch({ type: ACTION_TYPES.RECEIVE_BO_BUSINESSFIELD, entities });
        }
    },
    requestPartnerOrParentBusinessFields: (positionId, occupationId) => async (dispatch) => {
        if (occupationId !== undefined) {
            dispatch({ type: ACTION_TYPES.REQUEST_PARTNER_OR_PARENT_BUSINESSFIELD });
            const url = `api/businessfield?id=${positionId}&occupationId=${occupationId}`;
            const response = await fetch(url);
            const entities = await response.json();

            dispatch({ type: ACTION_TYPES.RECEIVE_PARTNER_OR_PARENT_BUSINESSFIELD, entities });
        }
    },

};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case (ACTION_TYPES.REQUEST_BUSINESSFIELD):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_BUSINESSFIELD):
            return {
                ...state,
                isLoading: false,
                entities: action.entities
            };
        case (ACTION_TYPES.REQUEST_BO_BUSINESSFIELD):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_BO_BUSINESSFIELD):
            return {
                ...state,
                isLoading: false,
                boBusinessFieldEntities: action.entities
            }
        case (ACTION_TYPES.REQUEST_PARTNER_OR_PARENT_BUSINESSFIELD):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_PARTNER_OR_PARENT_BUSINESSFIELD):
            return {
                ...state,
                isLoading: false,
                partnerOrParentBusinessFieldEntities: action.entities
            }
        default:
            return state;
    }

};



// WEBPACK FOOTER //
// ./src/store/BusinessField.Reducer.js